import store from '@/store'

export default async (to, from, next) => {
  if (store.getters['auth/user'].role !== 'admin') {
    next({ name: 'home' })
  }
  next()
}


// WEBPACK FOOTER //
// ./src/middleware/admin.js